import Papa from "papaparse";


const dataTableUtil = {

    toCSV: function ( tableColumns, tableRows) {
        let header = "";
        let columns = [];
        tableColumns.forEach(function(item) {
            if(header != "")
                header += ",";
            header += "\"" + item.label + "\"";
            columns.push(item.field);
        });
        header = header + "\n";

        let csv = header;
        csv += Papa.unparse(tableRows, {header: false, columns: columns});
        return csv;
    },

    beginDownload(fileName, content) {
        var downloadLink = document.createElement("a");
        var blob = new Blob(["\ufeff", content]);
        var url = URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = fileName;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
};

export default dataTableUtil